import React, { Component } from 'react';
import { Drawer } from 'antd';
import { ExplainerView } from '@get-aico/get-explainer-view';
import { apiUtil as Util } from '../../mock/mockServices';

/**
 * Thin host wrapper around the shared explainer library
 * (`@get-aico/get-explainer-view`, published from model-explainer/frontend).
 *
 * All explainer UI and logic lives in the library; this file only provides
 * the get-ui Drawer chrome and maps the historical props (visible / model /
 * onClose) to ExplainerView props.
 */
class ModelExplanation extends Component {
  render() {
    const { visible, onClose, model } = this.props;

    const modelId = model ? (model.modelId || model.id) : null;
    // Prediction explanations are flagged by `fileName` on the record (same
    // convention the old inline implementation used).
    const predictionId = model && model.hasOwnProperty('fileName')
      ? (model.predictionId || model.trainId)
      : null;

    return (
      <Drawer
        title={model ? `Model Explanation: ${model.projectName || model.modelName || modelId || 'Unknown'}` : "Model Explanation"}
        visible={visible}
        onClose={onClose}
        width={1200}
        placement="right"
      >
        {model && modelId ? (
          <ExplainerView
            modelId={String(modelId)}
            predictionId={predictionId != null ? String(predictionId) : null}
            apiClient={Util.ajax}
          />
        ) : null}
      </Drawer>
    );
  }
}

export default ModelExplanation;
